import DgBackToTop from './src/main.vue'

// 为组件提供 install 安装方法，供按需引入
DgBackToTop.install = function (Vue) {
  Vue.component(DgBackToTop.name, DgBackToTop)
}
export default DgBackToTop

export { DgBackToTop }